import { useSmallScreen } from "Shared/Hooks";
import { isUMSUrl } from "./isUMSUrl";

export const useShowHeader = () => {
    const isSmallScreen = useSmallScreen();

    if (isUMSUrl) {
        return false;
    }
    if (isSmallScreen) {
        return false;
    }
    return true;
};
